export default "__VITE_ASSET__DtI1CXwa__"